/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAutomationRouteImport } from './routes/_app/automation'
import { Route as AppBuilderRouteImport } from './routes/_app/builder'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as OnboardingAccountTypeRouteImport } from './routes/onboarding/account-type'
import { Route as OnboardingProfileRouteImport } from './routes/onboarding/profile'
import { Route as OnboardingTaxRegimeRouteImport } from './routes/onboarding/tax-regime'
import { Route as AppAdminRolesRouteImport } from './routes/_app/admin/roles'
import { Route as AppBuilderIndexRouteImport } from './routes/_app/builder/index'
import { Route as AppBuilderProfileIdRouteImport } from './routes/_app/builder/$profileId'
import { Route as AppDealsIndexRouteImport } from './routes/_app/deals/index'
import { Route as AppDealsDealIdRouteImport } from './routes/_app/deals/$dealId'
import { Route as AppDealsActiveRouteImport } from './routes/_app/deals/active'
import { Route as AppDealsCompletedRouteImport } from './routes/_app/deals/completed'
import { Route as AppDocumentsIndexRouteImport } from './routes/_app/documents/index'
import { Route as AppDocumentsDocumentIdRouteImport } from './routes/_app/documents/$documentId'
import { Route as AppDocumentsRegistryRouteImport } from './routes/_app/documents/registry'
import { Route as AppDocumentsTemplatesRouteImport } from './routes/_app/documents/templates'
import { Route as AppFinancesIndexRouteImport } from './routes/_app/finances/index'
import { Route as AppFinancesTransactionsRouteImport } from './routes/_app/finances/transactions'
import { Route as AppPropertiesIndexRouteImport } from './routes/_app/properties/index'
import { Route as AppPropertiesPropertyIdRouteImport } from './routes/_app/properties/$propertyId'
import { Route as AppPropertiesArchiveRouteImport } from './routes/_app/properties/archive'
import { Route as AppPropertiesAvailableRouteImport } from './routes/_app/properties/available'
import { Route as AppPropertiesDraftsRouteImport } from './routes/_app/properties/drafts'
import { Route as AppPropertiesPublishedRouteImport } from './routes/_app/properties/published'
import { Route as AppPropertiesRegistryRouteImport } from './routes/_app/properties/registry'
import { Route as AppPropertiesRentedRouteImport } from './routes/_app/properties/rented'
import { Route as AppRentIndexRouteImport } from './routes/_app/rent/index'
import { Route as AppRentRentalIdRouteImport } from './routes/_app/rent/$rentalId'
import { Route as AppRentActiveRouteImport } from './routes/_app/rent/active'
import { Route as AppRentClosingRouteImport } from './routes/_app/rent/closing'
import { Route as AppRentCompletedRouteImport } from './routes/_app/rent/completed'
import { Route as AppRentUpcomingRouteImport } from './routes/_app/rent/upcoming'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAccessLogRouteImport } from './routes/_app/settings/access-log'
import { Route as AppSettingsAppBuilderRouteImport } from './routes/_app/settings/app-builder'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppSettingsDocumentsRouteImport } from './routes/_app/settings/documents'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsSiteBuilderRouteImport } from './routes/_app/settings/site-builder'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/settings/team'
import { Route as AppTenantsIndexRouteImport } from './routes/_app/tenants/index'
import { Route as AppTenantsTenantIdRouteImport } from './routes/_app/tenants/$tenantId'
import { Route as AppTenantsCurrentRouteImport } from './routes/_app/tenants/current'
import { Route as AppTenantsPastRouteImport } from './routes/_app/tenants/past'
import { Route as AppTenantsUpcomingRouteImport } from './routes/_app/tenants/upcoming'
import { Route as OauthAvitoCallbackRouteImport } from './routes/oauth.avito.callback'
import { Route as AppFinancesInvoicesIndexRouteImport } from './routes/_app/finances/invoices/index'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationRoute = AppAutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => AppRoute,
} as any)
const AppBuilderRoute = AppBuilderRouteImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const OnboardingAccountTypeRoute = OnboardingAccountTypeRouteImport.update({
  id: '/account-type',
  path: '/account-type',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingProfileRoute = OnboardingProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingTaxRegimeRoute = OnboardingTaxRegimeRouteImport.update({
  id: '/tax-regime',
  path: '/tax-regime',
  getParentRoute: () => OnboardingRoute,
} as any)
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppBuilderIndexRoute = AppBuilderIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppBuilderProfileIdRoute = AppBuilderProfileIdRouteImport.update({
  id: '/$profileId',
  path: '/$profileId',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppDealsIndexRoute = AppDealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsDealIdRoute = AppDealsDealIdRouteImport.update({
  id: '/deals/$dealId',
  path: '/deals/$dealId',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsActiveRoute = AppDealsActiveRouteImport.update({
  id: '/deals/active',
  path: '/deals/active',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsCompletedRoute = AppDealsCompletedRouteImport.update({
  id: '/deals/completed',
  path: '/deals/completed',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsDocumentIdRoute = AppDocumentsDocumentIdRouteImport.update({
  id: '/documents/$documentId',
  path: '/documents/$documentId',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRegistryRoute = AppDocumentsRegistryRouteImport.update({
  id: '/documents/registry',
  path: '/documents/registry',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsTemplatesRoute = AppDocumentsTemplatesRouteImport.update({
  id: '/documents/templates',
  path: '/documents/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancesIndexRoute = AppFinancesIndexRouteImport.update({
  id: '/finances/',
  path: '/finances/',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancesTransactionsRoute = AppFinancesTransactionsRouteImport.update({
  id: '/finances/transactions',
  path: '/finances/transactions',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesIndexRoute = AppPropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesPropertyIdRoute = AppPropertiesPropertyIdRouteImport.update({
  id: '/properties/$propertyId',
  path: '/properties/$propertyId',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesArchiveRoute = AppPropertiesArchiveRouteImport.update({
  id: '/properties/archive',
  path: '/properties/archive',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesAvailableRoute = AppPropertiesAvailableRouteImport.update({
  id: '/properties/available',
  path: '/properties/available',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesDraftsRoute = AppPropertiesDraftsRouteImport.update({
  id: '/properties/drafts',
  path: '/properties/drafts',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesPublishedRoute = AppPropertiesPublishedRouteImport.update({
  id: '/properties/published',
  path: '/properties/published',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesRegistryRoute = AppPropertiesRegistryRouteImport.update({
  id: '/properties/registry',
  path: '/properties/registry',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesRentedRoute = AppPropertiesRentedRouteImport.update({
  id: '/properties/rented',
  path: '/properties/rented',
  getParentRoute: () => AppRoute,
} as any)
const AppRentIndexRoute = AppRentIndexRouteImport.update({
  id: '/rent/',
  path: '/rent/',
  getParentRoute: () => AppRoute,
} as any)
const AppRentRentalIdRoute = AppRentRentalIdRouteImport.update({
  id: '/rent/$rentalId',
  path: '/rent/$rentalId',
  getParentRoute: () => AppRoute,
} as any)
const AppRentActiveRoute = AppRentActiveRouteImport.update({
  id: '/rent/active',
  path: '/rent/active',
  getParentRoute: () => AppRoute,
} as any)
const AppRentClosingRoute = AppRentClosingRouteImport.update({
  id: '/rent/closing',
  path: '/rent/closing',
  getParentRoute: () => AppRoute,
} as any)
const AppRentCompletedRoute = AppRentCompletedRouteImport.update({
  id: '/rent/completed',
  path: '/rent/completed',
  getParentRoute: () => AppRoute,
} as any)
const AppRentUpcomingRoute = AppRentUpcomingRouteImport.update({
  id: '/rent/upcoming',
  path: '/rent/upcoming',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAccessLogRoute = AppSettingsAccessLogRouteImport.update({
  id: '/access-log',
  path: '/access-log',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAppBuilderRoute = AppSettingsAppBuilderRouteImport.update({
  id: '/app-builder',
  path: '/app-builder',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDocumentsRoute = AppSettingsDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSiteBuilderRoute = AppSettingsSiteBuilderRouteImport.update({
  id: '/site-builder',
  path: '/site-builder',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppTenantsIndexRoute = AppTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => AppRoute,
} as any)
const AppTenantsTenantIdRoute = AppTenantsTenantIdRouteImport.update({
  id: '/tenants/$tenantId',
  path: '/tenants/$tenantId',
  getParentRoute: () => AppRoute,
} as any)
const AppTenantsCurrentRoute = AppTenantsCurrentRouteImport.update({
  id: '/tenants/current',
  path: '/tenants/current',
  getParentRoute: () => AppRoute,
} as any)
const AppTenantsPastRoute = AppTenantsPastRouteImport.update({
  id: '/tenants/past',
  path: '/tenants/past',
  getParentRoute: () => AppRoute,
} as any)
const AppTenantsUpcomingRoute = AppTenantsUpcomingRouteImport.update({
  id: '/tenants/upcoming',
  path: '/tenants/upcoming',
  getParentRoute: () => AppRoute,
} as any)
const OauthAvitoCallbackRoute = OauthAvitoCallbackRouteImport.update({
  id: '/oauth/avito/callback',
  path: '/oauth/avito/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppFinancesInvoicesIndexRoute =
  AppFinancesInvoicesIndexRouteImport.update({
    id: '/finances/invoices/',
    path: '/finances/invoices/',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/callback': typeof CallbackRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/automation': typeof AppAutomationRoute
  '/builder': typeof AppBuilderRouteWithChildren
  '/settings': typeof AppSettingsRouteWithChildren
  '/tasks': typeof AppTasksRoute
  '/onboarding/account-type': typeof OnboardingAccountTypeRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/tax-regime': typeof OnboardingTaxRegimeRoute
  '/admin/roles': typeof AppAdminRolesRoute
  '/builder/$profileId': typeof AppBuilderProfileIdRoute
  '/deals/$dealId': typeof AppDealsDealIdRoute
  '/deals/active': typeof AppDealsActiveRoute
  '/deals/completed': typeof AppDealsCompletedRoute
  '/documents/$documentId': typeof AppDocumentsDocumentIdRoute
  '/documents/registry': typeof AppDocumentsRegistryRoute
  '/documents/templates': typeof AppDocumentsTemplatesRoute
  '/finances/transactions': typeof AppFinancesTransactionsRoute
  '/properties/$propertyId': typeof AppPropertiesPropertyIdRoute
  '/properties/archive': typeof AppPropertiesArchiveRoute
  '/properties/available': typeof AppPropertiesAvailableRoute
  '/properties/drafts': typeof AppPropertiesDraftsRoute
  '/properties/published': typeof AppPropertiesPublishedRoute
  '/properties/registry': typeof AppPropertiesRegistryRoute
  '/properties/rented': typeof AppPropertiesRentedRoute
  '/rent/$rentalId': typeof AppRentRentalIdRoute
  '/rent/active': typeof AppRentActiveRoute
  '/rent/closing': typeof AppRentClosingRoute
  '/rent/completed': typeof AppRentCompletedRoute
  '/rent/upcoming': typeof AppRentUpcomingRoute
  '/settings/access-log': typeof AppSettingsAccessLogRoute
  '/settings/app-builder': typeof AppSettingsAppBuilderRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/documents': typeof AppSettingsDocumentsRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/site-builder': typeof AppSettingsSiteBuilderRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/tenants/$tenantId': typeof AppTenantsTenantIdRoute
  '/tenants/current': typeof AppTenantsCurrentRoute
  '/tenants/past': typeof AppTenantsPastRoute
  '/tenants/upcoming': typeof AppTenantsUpcomingRoute
  '/oauth/avito/callback': typeof OauthAvitoCallbackRoute
  '/builder/': typeof AppBuilderIndexRoute
  '/deals/': typeof AppDealsIndexRoute
  '/documents/': typeof AppDocumentsIndexRoute
  '/finances/': typeof AppFinancesIndexRoute
  '/properties/': typeof AppPropertiesIndexRoute
  '/rent/': typeof AppRentIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/tenants/': typeof AppTenantsIndexRoute
  '/finances/invoices/': typeof AppFinancesInvoicesIndexRoute
}
export interface FileRoutesByTo {
  '/callback': typeof CallbackRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/automation': typeof AppAutomationRoute
  '/tasks': typeof AppTasksRoute
  '/onboarding/account-type': typeof OnboardingAccountTypeRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/tax-regime': typeof OnboardingTaxRegimeRoute
  '/': typeof AppIndexRoute
  '/admin/roles': typeof AppAdminRolesRoute
  '/builder/$profileId': typeof AppBuilderProfileIdRoute
  '/deals/$dealId': typeof AppDealsDealIdRoute
  '/deals/active': typeof AppDealsActiveRoute
  '/deals/completed': typeof AppDealsCompletedRoute
  '/documents/$documentId': typeof AppDocumentsDocumentIdRoute
  '/documents/registry': typeof AppDocumentsRegistryRoute
  '/documents/templates': typeof AppDocumentsTemplatesRoute
  '/finances/transactions': typeof AppFinancesTransactionsRoute
  '/properties/$propertyId': typeof AppPropertiesPropertyIdRoute
  '/properties/archive': typeof AppPropertiesArchiveRoute
  '/properties/available': typeof AppPropertiesAvailableRoute
  '/properties/drafts': typeof AppPropertiesDraftsRoute
  '/properties/published': typeof AppPropertiesPublishedRoute
  '/properties/registry': typeof AppPropertiesRegistryRoute
  '/properties/rented': typeof AppPropertiesRentedRoute
  '/rent/$rentalId': typeof AppRentRentalIdRoute
  '/rent/active': typeof AppRentActiveRoute
  '/rent/closing': typeof AppRentClosingRoute
  '/rent/completed': typeof AppRentCompletedRoute
  '/rent/upcoming': typeof AppRentUpcomingRoute
  '/settings/access-log': typeof AppSettingsAccessLogRoute
  '/settings/app-builder': typeof AppSettingsAppBuilderRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/documents': typeof AppSettingsDocumentsRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/site-builder': typeof AppSettingsSiteBuilderRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/tenants/$tenantId': typeof AppTenantsTenantIdRoute
  '/tenants/current': typeof AppTenantsCurrentRoute
  '/tenants/past': typeof AppTenantsPastRoute
  '/tenants/upcoming': typeof AppTenantsUpcomingRoute
  '/oauth/avito/callback': typeof OauthAvitoCallbackRoute
  '/builder': typeof AppBuilderIndexRoute
  '/deals': typeof AppDealsIndexRoute
  '/documents': typeof AppDocumentsIndexRoute
  '/finances': typeof AppFinancesIndexRoute
  '/properties': typeof AppPropertiesIndexRoute
  '/rent': typeof AppRentIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/tenants': typeof AppTenantsIndexRoute
  '/finances/invoices': typeof AppFinancesInvoicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/callback': typeof CallbackRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/_app/automation': typeof AppAutomationRoute
  '/_app/builder': typeof AppBuilderRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/tasks': typeof AppTasksRoute
  '/onboarding/account-type': typeof OnboardingAccountTypeRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/tax-regime': typeof OnboardingTaxRegimeRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/roles': typeof AppAdminRolesRoute
  '/_app/builder/$profileId': typeof AppBuilderProfileIdRoute
  '/_app/deals/$dealId': typeof AppDealsDealIdRoute
  '/_app/deals/active': typeof AppDealsActiveRoute
  '/_app/deals/completed': typeof AppDealsCompletedRoute
  '/_app/documents/$documentId': typeof AppDocumentsDocumentIdRoute
  '/_app/documents/registry': typeof AppDocumentsRegistryRoute
  '/_app/documents/templates': typeof AppDocumentsTemplatesRoute
  '/_app/finances/transactions': typeof AppFinancesTransactionsRoute
  '/_app/properties/$propertyId': typeof AppPropertiesPropertyIdRoute
  '/_app/properties/archive': typeof AppPropertiesArchiveRoute
  '/_app/properties/available': typeof AppPropertiesAvailableRoute
  '/_app/properties/drafts': typeof AppPropertiesDraftsRoute
  '/_app/properties/published': typeof AppPropertiesPublishedRoute
  '/_app/properties/registry': typeof AppPropertiesRegistryRoute
  '/_app/properties/rented': typeof AppPropertiesRentedRoute
  '/_app/rent/$rentalId': typeof AppRentRentalIdRoute
  '/_app/rent/active': typeof AppRentActiveRoute
  '/_app/rent/closing': typeof AppRentClosingRoute
  '/_app/rent/completed': typeof AppRentCompletedRoute
  '/_app/rent/upcoming': typeof AppRentUpcomingRoute
  '/_app/settings/access-log': typeof AppSettingsAccessLogRoute
  '/_app/settings/app-builder': typeof AppSettingsAppBuilderRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/documents': typeof AppSettingsDocumentsRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/site-builder': typeof AppSettingsSiteBuilderRoute
  '/_app/settings/team': typeof AppSettingsTeamRoute
  '/_app/tenants/$tenantId': typeof AppTenantsTenantIdRoute
  '/_app/tenants/current': typeof AppTenantsCurrentRoute
  '/_app/tenants/past': typeof AppTenantsPastRoute
  '/_app/tenants/upcoming': typeof AppTenantsUpcomingRoute
  '/oauth/avito/callback': typeof OauthAvitoCallbackRoute
  '/_app/builder/': typeof AppBuilderIndexRoute
  '/_app/deals/': typeof AppDealsIndexRoute
  '/_app/documents/': typeof AppDocumentsIndexRoute
  '/_app/finances/': typeof AppFinancesIndexRoute
  '/_app/properties/': typeof AppPropertiesIndexRoute
  '/_app/rent/': typeof AppRentIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/tenants/': typeof AppTenantsIndexRoute
  '/_app/finances/invoices/': typeof AppFinancesInvoicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/onboarding'
    | '/automation'
    | '/builder'
    | '/settings'
    | '/tasks'
    | '/onboarding/account-type'
    | '/onboarding/profile'
    | '/onboarding/tax-regime'
    | '/admin/roles'
    | '/builder/$profileId'
    | '/deals/$dealId'
    | '/deals/active'
    | '/deals/completed'
    | '/documents/$documentId'
    | '/documents/registry'
    | '/documents/templates'
    | '/finances/transactions'
    | '/properties/$propertyId'
    | '/properties/archive'
    | '/properties/available'
    | '/properties/drafts'
    | '/properties/published'
    | '/properties/registry'
    | '/properties/rented'
    | '/rent/$rentalId'
    | '/rent/active'
    | '/rent/closing'
    | '/rent/completed'
    | '/rent/upcoming'
    | '/settings/access-log'
    | '/settings/app-builder'
    | '/settings/billing'
    | '/settings/documents'
    | '/settings/integrations'
    | '/settings/profile'
    | '/settings/site-builder'
    | '/settings/team'
    | '/tenants/$tenantId'
    | '/tenants/current'
    | '/tenants/past'
    | '/tenants/upcoming'
    | '/oauth/avito/callback'
    | '/builder/'
    | '/deals/'
    | '/documents/'
    | '/finances/'
    | '/properties/'
    | '/rent/'
    | '/settings/'
    | '/tenants/'
    | '/finances/invoices/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/callback'
    | '/onboarding'
    | '/automation'
    | '/tasks'
    | '/onboarding/account-type'
    | '/onboarding/profile'
    | '/onboarding/tax-regime'
    | '/'
    | '/admin/roles'
    | '/builder/$profileId'
    | '/deals/$dealId'
    | '/deals/active'
    | '/deals/completed'
    | '/documents/$documentId'
    | '/documents/registry'
    | '/documents/templates'
    | '/finances/transactions'
    | '/properties/$propertyId'
    | '/properties/archive'
    | '/properties/available'
    | '/properties/drafts'
    | '/properties/published'
    | '/properties/registry'
    | '/properties/rented'
    | '/rent/$rentalId'
    | '/rent/active'
    | '/rent/closing'
    | '/rent/completed'
    | '/rent/upcoming'
    | '/settings/access-log'
    | '/settings/app-builder'
    | '/settings/billing'
    | '/settings/documents'
    | '/settings/integrations'
    | '/settings/profile'
    | '/settings/site-builder'
    | '/settings/team'
    | '/tenants/$tenantId'
    | '/tenants/current'
    | '/tenants/past'
    | '/tenants/upcoming'
    | '/oauth/avito/callback'
    | '/builder'
    | '/deals'
    | '/documents'
    | '/finances'
    | '/properties'
    | '/rent'
    | '/settings'
    | '/tenants'
    | '/finances/invoices'
  id:
    | '__root__'
    | '/_app'
    | '/callback'
    | '/onboarding'
    | '/_app/automation'
    | '/_app/builder'
    | '/_app/settings'
    | '/_app/tasks'
    | '/onboarding/account-type'
    | '/onboarding/profile'
    | '/onboarding/tax-regime'
    | '/_app/'
    | '/_app/admin/roles'
    | '/_app/builder/$profileId'
    | '/_app/deals/$dealId'
    | '/_app/deals/active'
    | '/_app/deals/completed'
    | '/_app/documents/$documentId'
    | '/_app/documents/registry'
    | '/_app/documents/templates'
    | '/_app/finances/transactions'
    | '/_app/properties/$propertyId'
    | '/_app/properties/archive'
    | '/_app/properties/available'
    | '/_app/properties/drafts'
    | '/_app/properties/published'
    | '/_app/properties/registry'
    | '/_app/properties/rented'
    | '/_app/rent/$rentalId'
    | '/_app/rent/active'
    | '/_app/rent/closing'
    | '/_app/rent/completed'
    | '/_app/rent/upcoming'
    | '/_app/settings/access-log'
    | '/_app/settings/app-builder'
    | '/_app/settings/billing'
    | '/_app/settings/documents'
    | '/_app/settings/integrations'
    | '/_app/settings/profile'
    | '/_app/settings/site-builder'
    | '/_app/settings/team'
    | '/_app/tenants/$tenantId'
    | '/_app/tenants/current'
    | '/_app/tenants/past'
    | '/_app/tenants/upcoming'
    | '/oauth/avito/callback'
    | '/_app/builder/'
    | '/_app/deals/'
    | '/_app/documents/'
    | '/_app/finances/'
    | '/_app/properties/'
    | '/_app/rent/'
    | '/_app/settings/'
    | '/_app/tenants/'
    | '/_app/finances/invoices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  OauthAvitoCallbackRoute: typeof OauthAvitoCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automation': {
      id: '/_app/automation'
      path: '/automation'
      fullPath: '/automation'
      preLoaderRoute: typeof AppAutomationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/builder': {
      id: '/_app/builder'
      path: '/builder'
      fullPath: '/builder'
      preLoaderRoute: typeof AppBuilderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/onboarding/account-type': {
      id: '/onboarding/account-type'
      path: '/account-type'
      fullPath: '/onboarding/account-type'
      preLoaderRoute: typeof OnboardingAccountTypeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/profile': {
      id: '/onboarding/profile'
      path: '/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof OnboardingProfileRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/tax-regime': {
      id: '/onboarding/tax-regime'
      path: '/tax-regime'
      fullPath: '/onboarding/tax-regime'
      preLoaderRoute: typeof OnboardingTaxRegimeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_app/admin/roles': {
      id: '/_app/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AppAdminRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/builder/': {
      id: '/_app/builder/'
      path: '/'
      fullPath: '/builder/'
      preLoaderRoute: typeof AppBuilderIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/$profileId': {
      id: '/_app/builder/$profileId'
      path: '/$profileId'
      fullPath: '/builder/$profileId'
      preLoaderRoute: typeof AppBuilderProfileIdRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/deals/': {
      id: '/_app/deals/'
      path: '/deals'
      fullPath: '/deals/'
      preLoaderRoute: typeof AppDealsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/$dealId': {
      id: '/_app/deals/$dealId'
      path: '/deals/$dealId'
      fullPath: '/deals/$dealId'
      preLoaderRoute: typeof AppDealsDealIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/active': {
      id: '/_app/deals/active'
      path: '/deals/active'
      fullPath: '/deals/active'
      preLoaderRoute: typeof AppDealsActiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/completed': {
      id: '/_app/deals/completed'
      path: '/deals/completed'
      fullPath: '/deals/completed'
      preLoaderRoute: typeof AppDealsCompletedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/': {
      id: '/_app/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/$documentId': {
      id: '/_app/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/documents/$documentId'
      preLoaderRoute: typeof AppDocumentsDocumentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/registry': {
      id: '/_app/documents/registry'
      path: '/documents/registry'
      fullPath: '/documents/registry'
      preLoaderRoute: typeof AppDocumentsRegistryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/templates': {
      id: '/_app/documents/templates'
      path: '/documents/templates'
      fullPath: '/documents/templates'
      preLoaderRoute: typeof AppDocumentsTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finances/': {
      id: '/_app/finances/'
      path: '/finances'
      fullPath: '/finances/'
      preLoaderRoute: typeof AppFinancesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finances/transactions': {
      id: '/_app/finances/transactions'
      path: '/finances/transactions'
      fullPath: '/finances/transactions'
      preLoaderRoute: typeof AppFinancesTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/': {
      id: '/_app/properties/'
      path: '/properties'
      fullPath: '/properties/'
      preLoaderRoute: typeof AppPropertiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/$propertyId': {
      id: '/_app/properties/$propertyId'
      path: '/properties/$propertyId'
      fullPath: '/properties/$propertyId'
      preLoaderRoute: typeof AppPropertiesPropertyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/archive': {
      id: '/_app/properties/archive'
      path: '/properties/archive'
      fullPath: '/properties/archive'
      preLoaderRoute: typeof AppPropertiesArchiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/available': {
      id: '/_app/properties/available'
      path: '/properties/available'
      fullPath: '/properties/available'
      preLoaderRoute: typeof AppPropertiesAvailableRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/drafts': {
      id: '/_app/properties/drafts'
      path: '/properties/drafts'
      fullPath: '/properties/drafts'
      preLoaderRoute: typeof AppPropertiesDraftsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/published': {
      id: '/_app/properties/published'
      path: '/properties/published'
      fullPath: '/properties/published'
      preLoaderRoute: typeof AppPropertiesPublishedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/registry': {
      id: '/_app/properties/registry'
      path: '/properties/registry'
      fullPath: '/properties/registry'
      preLoaderRoute: typeof AppPropertiesRegistryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/rented': {
      id: '/_app/properties/rented'
      path: '/properties/rented'
      fullPath: '/properties/rented'
      preLoaderRoute: typeof AppPropertiesRentedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rent/': {
      id: '/_app/rent/'
      path: '/rent'
      fullPath: '/rent/'
      preLoaderRoute: typeof AppRentIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rent/$rentalId': {
      id: '/_app/rent/$rentalId'
      path: '/rent/$rentalId'
      fullPath: '/rent/$rentalId'
      preLoaderRoute: typeof AppRentRentalIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rent/active': {
      id: '/_app/rent/active'
      path: '/rent/active'
      fullPath: '/rent/active'
      preLoaderRoute: typeof AppRentActiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rent/closing': {
      id: '/_app/rent/closing'
      path: '/rent/closing'
      fullPath: '/rent/closing'
      preLoaderRoute: typeof AppRentClosingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rent/completed': {
      id: '/_app/rent/completed'
      path: '/rent/completed'
      fullPath: '/rent/completed'
      preLoaderRoute: typeof AppRentCompletedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rent/upcoming': {
      id: '/_app/rent/upcoming'
      path: '/rent/upcoming'
      fullPath: '/rent/upcoming'
      preLoaderRoute: typeof AppRentUpcomingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/access-log': {
      id: '/_app/settings/access-log'
      path: '/access-log'
      fullPath: '/settings/access-log'
      preLoaderRoute: typeof AppSettingsAccessLogRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/app-builder': {
      id: '/_app/settings/app-builder'
      path: '/app-builder'
      fullPath: '/settings/app-builder'
      preLoaderRoute: typeof AppSettingsAppBuilderRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/documents': {
      id: '/_app/settings/documents'
      path: '/documents'
      fullPath: '/settings/documents'
      preLoaderRoute: typeof AppSettingsDocumentsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/site-builder': {
      id: '/_app/settings/site-builder'
      path: '/site-builder'
      fullPath: '/settings/site-builder'
      preLoaderRoute: typeof AppSettingsSiteBuilderRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/team': {
      id: '/_app/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/tenants/': {
      id: '/_app/tenants/'
      path: '/tenants'
      fullPath: '/tenants/'
      preLoaderRoute: typeof AppTenantsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tenants/$tenantId': {
      id: '/_app/tenants/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/tenants/$tenantId'
      preLoaderRoute: typeof AppTenantsTenantIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tenants/current': {
      id: '/_app/tenants/current'
      path: '/tenants/current'
      fullPath: '/tenants/current'
      preLoaderRoute: typeof AppTenantsCurrentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tenants/past': {
      id: '/_app/tenants/past'
      path: '/tenants/past'
      fullPath: '/tenants/past'
      preLoaderRoute: typeof AppTenantsPastRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tenants/upcoming': {
      id: '/_app/tenants/upcoming'
      path: '/tenants/upcoming'
      fullPath: '/tenants/upcoming'
      preLoaderRoute: typeof AppTenantsUpcomingRouteImport
      parentRoute: typeof AppRoute
    }
    '/oauth/avito/callback': {
      id: '/oauth/avito/callback'
      path: '/oauth/avito/callback'
      fullPath: '/oauth/avito/callback'
      preLoaderRoute: typeof OauthAvitoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/finances/invoices/': {
      id: '/_app/finances/invoices/'
      path: '/finances/invoices'
      fullPath: '/finances/invoices/'
      preLoaderRoute: typeof AppFinancesInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppBuilderRouteChildren {
  AppBuilderProfileIdRoute: typeof AppBuilderProfileIdRoute
  AppBuilderIndexRoute: typeof AppBuilderIndexRoute
}

const AppBuilderRouteChildren: AppBuilderRouteChildren = {
  AppBuilderProfileIdRoute: AppBuilderProfileIdRoute,
  AppBuilderIndexRoute: AppBuilderIndexRoute,
}

const AppBuilderRouteWithChildren = AppBuilderRoute._addFileChildren(
  AppBuilderRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAccessLogRoute: typeof AppSettingsAccessLogRoute
  AppSettingsAppBuilderRoute: typeof AppSettingsAppBuilderRoute
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsDocumentsRoute: typeof AppSettingsDocumentsRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsSiteBuilderRoute: typeof AppSettingsSiteBuilderRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAccessLogRoute: AppSettingsAccessLogRoute,
  AppSettingsAppBuilderRoute: AppSettingsAppBuilderRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsDocumentsRoute: AppSettingsDocumentsRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSiteBuilderRoute: AppSettingsSiteBuilderRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppAutomationRoute: typeof AppAutomationRoute
  AppBuilderRoute: typeof AppBuilderRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTasksRoute: typeof AppTasksRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminRolesRoute: typeof AppAdminRolesRoute
  AppDealsDealIdRoute: typeof AppDealsDealIdRoute
  AppDealsActiveRoute: typeof AppDealsActiveRoute
  AppDealsCompletedRoute: typeof AppDealsCompletedRoute
  AppDocumentsDocumentIdRoute: typeof AppDocumentsDocumentIdRoute
  AppDocumentsRegistryRoute: typeof AppDocumentsRegistryRoute
  AppDocumentsTemplatesRoute: typeof AppDocumentsTemplatesRoute
  AppFinancesTransactionsRoute: typeof AppFinancesTransactionsRoute
  AppPropertiesPropertyIdRoute: typeof AppPropertiesPropertyIdRoute
  AppPropertiesArchiveRoute: typeof AppPropertiesArchiveRoute
  AppPropertiesAvailableRoute: typeof AppPropertiesAvailableRoute
  AppPropertiesDraftsRoute: typeof AppPropertiesDraftsRoute
  AppPropertiesPublishedRoute: typeof AppPropertiesPublishedRoute
  AppPropertiesRegistryRoute: typeof AppPropertiesRegistryRoute
  AppPropertiesRentedRoute: typeof AppPropertiesRentedRoute
  AppRentRentalIdRoute: typeof AppRentRentalIdRoute
  AppRentActiveRoute: typeof AppRentActiveRoute
  AppRentClosingRoute: typeof AppRentClosingRoute
  AppRentCompletedRoute: typeof AppRentCompletedRoute
  AppRentUpcomingRoute: typeof AppRentUpcomingRoute
  AppTenantsTenantIdRoute: typeof AppTenantsTenantIdRoute
  AppTenantsCurrentRoute: typeof AppTenantsCurrentRoute
  AppTenantsPastRoute: typeof AppTenantsPastRoute
  AppTenantsUpcomingRoute: typeof AppTenantsUpcomingRoute
  AppDealsIndexRoute: typeof AppDealsIndexRoute
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
  AppFinancesIndexRoute: typeof AppFinancesIndexRoute
  AppPropertiesIndexRoute: typeof AppPropertiesIndexRoute
  AppRentIndexRoute: typeof AppRentIndexRoute
  AppTenantsIndexRoute: typeof AppTenantsIndexRoute
  AppFinancesInvoicesIndexRoute: typeof AppFinancesInvoicesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAutomationRoute: AppAutomationRoute,
  AppBuilderRoute: AppBuilderRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTasksRoute: AppTasksRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminRolesRoute: AppAdminRolesRoute,
  AppDealsDealIdRoute: AppDealsDealIdRoute,
  AppDealsActiveRoute: AppDealsActiveRoute,
  AppDealsCompletedRoute: AppDealsCompletedRoute,
  AppDocumentsDocumentIdRoute: AppDocumentsDocumentIdRoute,
  AppDocumentsRegistryRoute: AppDocumentsRegistryRoute,
  AppDocumentsTemplatesRoute: AppDocumentsTemplatesRoute,
  AppFinancesTransactionsRoute: AppFinancesTransactionsRoute,
  AppPropertiesPropertyIdRoute: AppPropertiesPropertyIdRoute,
  AppPropertiesArchiveRoute: AppPropertiesArchiveRoute,
  AppPropertiesAvailableRoute: AppPropertiesAvailableRoute,
  AppPropertiesDraftsRoute: AppPropertiesDraftsRoute,
  AppPropertiesPublishedRoute: AppPropertiesPublishedRoute,
  AppPropertiesRegistryRoute: AppPropertiesRegistryRoute,
  AppPropertiesRentedRoute: AppPropertiesRentedRoute,
  AppRentRentalIdRoute: AppRentRentalIdRoute,
  AppRentActiveRoute: AppRentActiveRoute,
  AppRentClosingRoute: AppRentClosingRoute,
  AppRentCompletedRoute: AppRentCompletedRoute,
  AppRentUpcomingRoute: AppRentUpcomingRoute,
  AppTenantsTenantIdRoute: AppTenantsTenantIdRoute,
  AppTenantsCurrentRoute: AppTenantsCurrentRoute,
  AppTenantsPastRoute: AppTenantsPastRoute,
  AppTenantsUpcomingRoute: AppTenantsUpcomingRoute,
  AppDealsIndexRoute: AppDealsIndexRoute,
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
  AppFinancesIndexRoute: AppFinancesIndexRoute,
  AppPropertiesIndexRoute: AppPropertiesIndexRoute,
  AppRentIndexRoute: AppRentIndexRoute,
  AppTenantsIndexRoute: AppTenantsIndexRoute,
  AppFinancesInvoicesIndexRoute: AppFinancesInvoicesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface OnboardingRouteChildren {
  OnboardingAccountTypeRoute: typeof OnboardingAccountTypeRoute
  OnboardingProfileRoute: typeof OnboardingProfileRoute
  OnboardingTaxRegimeRoute: typeof OnboardingTaxRegimeRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingAccountTypeRoute: OnboardingAccountTypeRoute,
  OnboardingProfileRoute: OnboardingProfileRoute,
  OnboardingTaxRegimeRoute: OnboardingTaxRegimeRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  CallbackRoute: CallbackRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  OauthAvitoCallbackRoute: OauthAvitoCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
